import { Typography } from "@mui/material";
import MainLayout from "../layouts/Mainlayout";

export default function About() {
  return (
    <MainLayout>
      <div className="max-w-4xl mx-auto text-center">
        <Typography variant="h4" gutterBottom>
          About Us 🌿
        </Typography>

        <p className="text-green-800">
          Vandevrai Foundation is dedicated to protecting nature, planting trees,
          and educating future generations about environmental conservation.
        </p>
      </div>
    </MainLayout>
  );
}